import React, { FC } from 'react'
import Skeleton from 'react-loading-skeleton'

import { Card } from '../Card'
import { Wrapper } from './Wrapper'

const LoadingSkeleton: FC = () => (
  <Card>
    <Skeleton count={2} height={16} wrapper={Wrapper} />
  </Card>
)

export { LoadingSkeleton }
